import { Integration, SDK } from '@commercetools/frontend-sdk';
import { ContentEvents } from '../types/events/ContentEvents';
import { ContentActions, getContentActions } from './actions/ContentActions';

class Content extends Integration<ContentEvents> {
  constructor(sdk: SDK<ContentEvents>) {
    super(sdk);

    this.content = getContentActions(sdk);
  }

  unregisterExtension(): void {}

  content: ContentActions;
}

export { Content };
